import React from 'react';

import type { Nullable } from '@clearverify/types';

import { useApiVerificationRequestQuery } from 'src/api';

type UseApiVerificationRequestParams = {
  inboxItemId?: Nullable<string>;
  skip?: boolean;
};

export const useApiVerificationRequest = ({
  inboxItemId,
  skip,
}: UseApiVerificationRequestParams) => {
  const { data, loading } = useApiVerificationRequestQuery({
    variables: { where: { inboxItemId: inboxItemId || '' } },
    skip: skip || !inboxItemId,
  });

  const apiVerificationRequest = React.useMemo(
    () => data?.apiVerificationRequest,
    [data?.apiVerificationRequest],
  );

  return { apiVerificationRequest, loading };
};
